import { createContext, useContext } from 'react';

export const SkinContext = createContext('regular');
export const useSkin = () => useContext(SkinContext);
export const SkinSettingsContext = createContext({ skin: 'regular', period: 'day', onSkinChange: () => {} });
export const useSkinSettings = () => useContext(SkinSettingsContext);
